<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="firePrevForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.extType }}</v-subheader>
              <div class="queryValue" v-for="item in filterExtTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="extTypeList"
                v-model="firePrevForm.extType"
                :label="labels.extType"
                item-text="label"
                item-value="value"
                data-vv-name="firePrevForm.extType"
                :data-vv-as="labels.extType"
                :error-messages="errors.collect('firePrevForm.extType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noExt }}</v-subheader>
              <div class="queryValue">{{ firePrevForm.noExt }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noExt"
                v-model="firePrevForm.noExt"
                :error-messages="errors.collect('firePrevForm.noExt')"
                data-vv-name="firePrevForm.noExt"
                :data-vv-as="labels.noExt"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noHoseReel }}</v-subheader>
              <div class="queryValue">{{ firePrevForm.noHoseReel }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noHoseReel"
                v-model="firePrevForm.noHoseReel"
                :error-messages="errors.collect('firePrevForm.noHoseReel')"
                data-vv-name="firePrevForm.noHoseReel"
                :data-vv-as="labels.noHoseReel"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.inspDate }}</v-subheader>
              <div class="queryValue">{{ formatDate(firePrevForm.inspDate) }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <cal-picker
                v-model="firePrevForm.inspDate"
                :label="labels.inspDate"
                :data-vv-as="labels.inspDate"
                data-vv-name="firePrevForm.inspDate"
              />
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.spr"
                v-model="firePrevForm.spr"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.smokeDet"
                v-model="firePrevForm.smokeDet"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.fireAlrm"
                v-model="firePrevForm.fireAlrm"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.hydrant"
                v-model="firePrevForm.hydrant"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.dryRiser"
                v-model="firePrevForm.dryRiser"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.wetRiser"
                v-model="firePrevForm.wetRiser"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.fireDrill"
                v-model="firePrevForm.fireDrill"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex md3 lg3></v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.nearFireSt }}</v-subheader>
              <div class="queryValue">{{ firePrevForm.nearFireSt }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.nearFireSt"
                v-model="firePrevForm.nearFireSt"
                :error-messages="errors.collect('firePrevForm.nearFireSt')"
                data-vv-name="firePrevForm.nearFireSt"
                :data-vv-as="labels.nearFireSt"
              ></v-text-field>
            </v-flex>
            <v-flex md6 lg6></v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.firePrevRemarks }}</v-subheader>
              <div class="queryValue">{{ firePrevForm.firePrevRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="firePrevForm.firePrevRemarks"
                :label="labels.firePrevRemarks"
                :error-messages="errors.collect('firePrevForm.firePrevRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="firePrevForm.firePrevRemarks"
                :data-vv-as="labels.firePrevRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { extTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        extType: 'Extinguisher Type',
        noExt: 'No. of Units',
        noHoseReel: 'No. of Hose Reels',
        inspDate: 'Inspection Date',
        spr: 'Sprinklers',
        smokeDet: 'Smoke Detectors',
        fireAlrm: 'Fire Alarm',
        hydrant: 'Hydrants nearby',
        dryRiser: 'Dry Riser',
        wetRiser: 'Wet Riser',
        fireDrill: 'Fire drills / training',
        nearFireSt: 'Nearest Fire Station',
        firePrevRemarks: 'Fire Prevention Comments'
      },
      firePrevForm: {
        survNo: undefined,
        verCnt: undefined,
        extType: undefined,
        noExt: 0,
        noHoseReel: 0,
        inspDate: undefined,
        spr: false,
        smokeDet: false,
        fireAlrm: false,
        hydrant: false,
        dryRiser: false,
        wetRiser: false,
        fireDrill: false,
        nearFireSt: undefined,
        firePrevRemarks: undefined,
        survDetType: 'firePrevention'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      extTypeList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterExtTypeList() {
      return this.extTypeList.filter((list) => {
        return list.value === parseInt(this.firePrevForm.extType)
      })
    }
  },
  methods: {
    async doInit() {
      this.firePrevForm.survNo = this.riskSurveyMaster.survNo
      this.firePrevForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.firePrevForm.extType = parseInt(this.riskSurveyDetails.extType)
      this.firePrevForm.noExt = this.riskSurveyDetails.noExt
      this.firePrevForm.noHoseReel = this.riskSurveyDetails.noHoseReel
      this.firePrevForm.inspDate = this.riskSurveyDetails.inspDate
      this.firePrevForm.spr = this.riskSurveyDetails.spr
      this.firePrevForm.smokeDet = this.riskSurveyDetails.smokeDet
      this.firePrevForm.fireAlrm = this.riskSurveyDetails.fireAlrm
      this.firePrevForm.hydrant = this.riskSurveyDetails.hydrant
      this.firePrevForm.dryRiser = this.riskSurveyDetails.dryRiser
      this.firePrevForm.wetRiser = this.riskSurveyDetails.wetRiser
      this.firePrevForm.fireDrill = this.riskSurveyDetails.fireDrill
      this.firePrevForm.nearFireSt = this.riskSurveyDetails.nearFireSt
      this.firePrevForm.firePrevRemarks = this.riskSurveyDetails.firePrevRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.firePrevForm.extType = undefined
      this.firePrevForm.noExt = 0
      this.firePrevForm.noHoseReel = 0
      this.firePrevForm.inspDate = undefined
      this.firePrevForm.spr = false
      this.firePrevForm.smokeDet = false
      this.firePrevForm.fireAlrm = false
      this.firePrevForm.hydrant = false
      this.firePrevForm.dryRiser = false
      this.firePrevForm.wetRiser = false
      this.firePrevForm.fireDrill = false
      this.firePrevForm.nearFireSt = undefined
      this.firePrevForm.firePrevRemarks = undefined
    }
  },
  created() {
    this.extTypeList = extTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
